import { render, staticRenderFns } from "./AppCoreHeader.vue?vue&type=template&id=31069f93&"
import script from "./AppCoreHeader.vue?vue&type=script&lang=js&"
export * from "./AppCoreHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports